import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloInstall } from '@api/sdk.gen';
import { KubesoloInstallPayload } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

/** Creates an environment for each machine, then installs KubeSolo on them in the background. Portainer clears the test. */
export function useInstallMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: KubesoloInstallPayload) => {
      const { data } = await kubesoloInstall({ body });
      return data.environmentIDs;
    },
    onSuccess: () => queryClient.setQueryData(queryKeys.active(), null),
    ...withError('Unable to install KubeSolo'),
  });
}
